import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Investisseur, InvestisseurFilterInput, InvestisseurType } from '../../models/generated/graphql';
import { OuiAutocomplete } from 'omnium-ui/form-field';
import { SearchInvestisseurAutocompleteComponent } from '../search-investisseur-autocomplete/search-investisseur-autocomplete.component';

@Component({
    selector: 'app-search-investisseur-personnes-morales',
    templateUrl: './search-investisseur-personnes-morales.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchInvestisseurPersonnesMoralesComponent {
  @ViewChild(SearchInvestisseurAutocompleteComponent)
  investisseurSelector: SearchInvestisseurAutocompleteComponent;
  protected readonly InvestisseurType = InvestisseurType;

  @Input() label = 'Investisseur (personne morale)';
  @Input() initInvestisseur: Investisseur | undefined;
  @Input() isInvestisseurSet = false;
  @Input() isRequired = false;
  @Input() isContactStatutExcluded = false;
  @Input() isClientStatutOnly = false;
  @Input() fullDisplay = true;
  @Input() defaultQueryFilter!: InvestisseurFilterInput;

  @Input() investisseurControl = new FormControl<number | undefined>(undefined);

  @Output() onInvestisseurIdSelected = new EventEmitter<number | null | undefined>();
  @Output() onInvestisseurPersonneSelected = new EventEmitter<Investisseur | undefined>();
}
